import { createContext } from 'react';
import { Campaign, Network } from '../types';

export interface CampaignContextType {
    campaigns: Campaign[];
    selectedCampaign: Campaign | null;
    setSelectedCampaign: (campaign: Campaign | null) => void;
    loadingCampaigns: boolean;
    selectedNetwork: Network | null;
    setSelectedNetwork: (network: Network | null) => void;
    refreshCampaigns: () => Promise<void>;
    loadCampaigns: () => Promise<void>;
}

export const CampaignContext = createContext<CampaignContextType | undefined>(undefined);
